module.exports = __webpack_public_path__ + "static/media/PDF_46.15cf773f.pdf";